import { useSeo } from '@/lib/seo';
import { Hero } from '@/components/site/Hero';
import { ClientLogos } from '@/components/site/ClientLogos';
import { SolutionFinder } from '@/components/site/SolutionFinder';
import { Services } from '@/components/site/Services';
import { SystemsShowcase } from '@/components/site/SystemsShowcase';
import { Audiences } from '@/components/site/Audiences';
import { Testimonials } from '@/components/site/Testimonials';
import { Insights } from '@/components/site/Insights';
import { CtaBand } from '@/components/site/CtaBand';

export default function HomePage() {
  useSeo({
    title: 'Amden Group | Business Consultancy Ireland — Operations, People, Growth & Launch',
    description:
      'Amden Group helps Irish and UK businesses streamline operations, strengthen recruitment, improve marketing and scale with practical systems.',
    canonical: 'https://amden.ie/',
  });

  return (
    <>
      <Hero />
      <Services />
      <ClientLogos />
      <SystemsShowcase />
      <SolutionFinder />
      <Audiences />
      <Testimonials />
      <Insights />
      <CtaBand />
    </>
  );
}
